import { useContext } from 'react';
import { SyncContext } from 'contexts/sync';
const CartTotal = () => {
    const { syncData } = useContext(SyncContext);
    return (syncData.Cart && typeof syncData.Cart.Total === 'number') ? syncData.Cart.Total : 0;
}

export default CartTotal;